import { forwardRef } from 'react';

import { IconProps } from '.';

export const InformationIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M10 17.5C8.51664 17.5 7.0666 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35472 9.99168 2.64411 8.53683C2.9335 7.08197 3.64781 5.7456 4.6967 4.6967C5.7456 3.64781 7.08197 2.9335 8.53683 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.07091C14.2406 3.63856 15.4119 4.59986 16.236 5.83323C17.0601 7.0666 17.5 8.51664 17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5ZM10 4C8.81332 4 7.65328 4.3519 6.66658 5.01119C5.67989 5.67047 4.91085 6.60755 4.45673 7.7039C4.0026 8.80026 3.88378 10.0067 4.11529 11.1705C4.3468 12.3344 4.91825 13.4035 5.75736 14.2426C6.59648 15.0818 7.66558 15.6532 8.82946 15.8847C9.99335 16.1162 11.1997 15.9974 12.2961 15.5433C13.3925 15.0892 14.3295 14.3201 14.9888 13.3334C15.6481 12.3467 16 11.1867 16 10C16 8.4087 15.3679 6.88258 14.2426 5.75736C13.1174 4.63214 11.5913 4 10 4Z"
        fill="currentColor"
      />
      <path
        d="M10 5.87C9.80268 5.87506 9.61485 5.9557 9.47528 6.09527C9.3357 6.23484 9.25506 6.42268 9.25 6.62C9.24816 6.82513 9.3272 7.02272 9.47 7.17C9.61525 7.3014 9.80413 7.37416 10 7.37416C10.1959 7.37416 10.3848 7.3014 10.53 7.17C10.6728 7.02272 10.7518 6.82513 10.75 6.62C10.7449 6.42268 10.6643 6.23484 10.5247 6.09527C10.3852 5.9557 10.1973 5.87506 10 5.87Z"
        fill="currentColor"
      />
      <path
        d="M10.75 8.88C10.75 8.46579 10.4142 8.13 10 8.13C9.58579 8.13 9.25 8.46579 9.25 8.88V13.38C9.25 13.7942 9.58579 14.13 10 14.13C10.4142 14.13 10.75 13.7942 10.75 13.38V8.88Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default InformationIcon;
